// extracted by mini-css-extract-plugin
export default {"icon":"style_icon__HGKuV","border":"style_border__VF4MN","none":"style_none__hdGNX"};